module.exports = __webpack_public_path__ + "static/media/language.db69340e.svg";